import { render, staticRenderFns } from "./MarkingsTypeSelectButtons.vue?vue&type=template&id=c028c334&scoped=true"
import script from "./MarkingsTypeSelectButtons.vue?vue&type=script&lang=js"
export * from "./MarkingsTypeSelectButtons.vue?vue&type=script&lang=js"
import style0 from "./MarkingsTypeSelectButtons.vue?vue&type=style&index=0&id=c028c334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c028c334",
  null
  
)

export default component.exports